<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HDLOL2/tc-custom/9780226925233.jpg?1722568411844" alt="This image is the cover for the book Excommunication, TRIOS"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Excommunication, TRIOS
      </h1>
      <p class="bookDescription body article font2">
        <p>Always connect—that is the imperative of today’s media. But what about those moments when media cease to function properly, when messages go beyond the sender and receiver to become excluded from the world of communication itself—those messages that state: “There will be no more messages”? In this book, Alexander R. Galloway, Eugene Thacker, and McKenzie Wark turn our usual understanding of media and mediation on its head by arguing that these moments reveal the ways the impossibility of communication is integral to communication itself—instances they call excommunication.  In three linked essays, <i>Excommunication</i> pursues this elusive topic by looking at mediation in the face of banishment, exclusion, and heresy, and by contemplating the possibilities of communication with the great beyond. First, Galloway proposes an original theory of mediation based on classical literature and philosophy, using Hermes, Iris, and the Furies to map out three of the most prevalent modes of mediation today—mediation as exchange, as illumination, and as network. Then, Thacker goes boldly beyond Galloway’s classification scheme by examining the concept of excommunication through the secret link between the modern horror genre and medieval mysticism. Charting a trajectory of examples from H. P. Lovecraft to Meister Eckhart, Thacker explores those instances when one communicates or connects with the inaccessible, dubbing such modes of mediation “haunted” or “weird” to underscore their inaccessibility. Finally, Wark evokes the poetics of the infuriated swarm as a queer politics of heresy that deviates from both media theory and the traditional left. He posits a critical theory that celebrates heresy and that is distinct from those that now venerate Saint Paul. Reexamining commonplace definitions of media, mediation, and communication, <i>Excommunication</i> offers a glimpse into the realm of the nonhuman to find a theory of mediation adequate to our present condition.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alexander R. Galloway, Eugene Thacker, McKenzie Wark
      </h2>
      
      <p class="authorDescription body article"><B>Alexander R. Galloway</B> is associate professor of media studies at New York University and lives in New York, NY. He is the author of four books on digital media and critical theory, most recently,&#160;<I>The Interface Effect</I>. <B>Eugene Thacker</B> is associate professor in the School of Media Studies at the New School and lives in Brooklyn, NY. He is the author of many books, including <I>After Life</I>, also published by the University of Chicago Press. <B>McKenzie Wark</B> is professor of liberal studies at The New School for Social Research and lives in Queens, NY. His books include <I>A Hacker Manifesto</I> and <I>Gamer Theory</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3deea258